import { ActionType } from "../../../../../../react-core/Flux/ActionType";
import { Dispatcher } from "../../../../../../react-core/Flux/Dispatcher";
import { CappedPensionArrangementsFlexiConversionAvailabilitiesStatic } from "./CappedPensionArrangementsFlexiConversionAvailabilitiesStatic";
import { ClientAccountStatic } from "./ClientAccountStatic";
import { ConvertToFlexiInstructionStatic } from "./ConvertToFlexiInstructionStatic";
import { PersonalDetailsStatic } from "./PersonalDetailsStatic";

export interface FluxResponse {
    actionType: ActionType;
    isLoading?: boolean;
    payload?: any;
}

export const ConvertToFlexiInstructionDispatcher: Dispatcher<FluxResponse> = new Dispatcher<FluxResponse>();
export const ConvertToFlexiInstructionStore: ConvertToFlexiInstructionStatic = new ConvertToFlexiInstructionStatic();


export const CappedPensionArrangementsFlexiConversionAvailabilitiesDispatcher: Dispatcher<FluxResponse> = new Dispatcher<FluxResponse>();
export const CappedPensionArrangementsFlexiConversionAvailabilitiesStore: CappedPensionArrangementsFlexiConversionAvailabilitiesStatic = new CappedPensionArrangementsFlexiConversionAvailabilitiesStatic();

export const PersonalDetailsDispatcher: Dispatcher<FluxResponse> = new Dispatcher<FluxResponse>();
export const PersonalDetailsStore: PersonalDetailsStatic = new PersonalDetailsStatic();

export const ClientAccountDispatcher: Dispatcher<FluxResponse> = new Dispatcher<FluxResponse>();
export const ClientAccountStore: ClientAccountStatic = new ClientAccountStatic();